<template>
  <div style="height: 649px;">
    <Card style="height: 100%;">
      <div style="text-align:center">
<!--        <img src="../../../assets/froeasy-logo-2.png" style="height: 100px;width: 100%;">-->
        <div class="describe-text">
          <Divider @click.native="getNoScanLayer">统计</Divider>
          <Row>
            <Col span="12">{{$t('scanNum.zbls')}}：</Col>
            <Col span="8">{{zbls}}</Col>
            <Col span="2">{{$t('scanNum.case')}}</Col>
          </Row>
          <Row>
            <Col span="12" @click.native="getNoScanLayer">{{$t('scanNum.zbps')}}：</Col>
            <Col span="8">{{zbps}}</Col>
            <Col span="2">{{$t('scanNum.leaf')}}</Col>
          </Row>
          <Row>
            <Col span="12">{{$t('scanNum.zupload')}}：</Col>
            <Col span="8">{{zupload}}</Col>
            <Col span="2">{{$t('scanNum.leaf')}}</Col>
          </Row>
          <Divider>{{$t('scanNum.yesterday')}}</Divider>
          <Row>
            <Col span="12">{{$t('scanNum.ydayCaseNum')}}：</Col>
            <Col span="8">{{ydayCaseNum}}</Col>
            <Col span="2">{{$t('scanNum.case')}}</Col>
          </Row>
          <Row>
            <Col span="12">{{$t('scanNum.ydaySlideNum')}}：</Col>
            <Col span="8">{{ydaySlideNum}}</Col>
            <Col span="2">{{$t('scanNum.leaf')}}</Col>
          </Row>
          <Row>
            <Col span="12">{{$t('scanNum.ydayLayerUpNum')}}：</Col>
            <Col span="8">{{ydayLayerNum}} / {{ydayUploadLayerNum}}</Col>
            <Col span="2">{{$t('scanNum.leaf')}}</Col>
          </Row>
          <Divider>{{$t('scanNum.today')}}</Divider>
          <Row>
            <Col span="12">{{$t('scanNum.tdayCaseNum')}}：</Col>
            <Col span="8">{{tdayCaseNum}}</Col>
            <Col span="2">{{$t('scanNum.case')}}</Col>
          </Row>
          <Row>
            <Col span="12">{{$t('scanNum.tdaySlideNum')}}：</Col>
            <Col span="8">{{tdaySlideNum}}</Col>
            <Col span="2">{{$t('scanNum.leaf')}}</Col>
          </Row>
          <Row>
            <Col span="12">{{$t('scanNum.tdayLayerUpNum')}}：</Col>
            <Col span="8">{{tdayLayerNum}} / {{tdayUploadLayerNum}}</Col>
            <Col span="2">{{$t('scanNum.leaf')}}</Col>
          </Row>
          <Divider />
          <Row>
            <Col span="12">{{$t('scanNum.dingScanNum')}}：</Col>
            <Col
              span="8"
              :style="dingScanNum >= 6 ? 'color: red; font-weight: bold; font-size: 20px;' : ''"
            >
              {{dingScanNum}}
            </Col>
            <Col span="2">{{$t('scanNum.leaf')}}</Col>
          </Row>
        </div>
<!--        <div style="margin-top: 50px;color: darkgray;text-align: left">-->
<!--          <p>注：当同时扫描中的数量大于1时，请确认扫描玻片是否出现异常中断扫描现象,并重新进行扫描。</p>-->
<!--        </div>-->
        <!--<div style="margin-top: 30%;">-->
          <!--<Button type="info" size="large" style="width: 160px;height:60px;">打印条码</Button>-->
          <!--<Button type="primary" size="large" style="width: 160px;height:60px;margin-top: 20%" @click="startScan">开始扫描</Button>-->
        <!--</div>-->
      </div>
    </Card>
    <div v-if="isShowNoScanLayer">
      <Modal v-model="isShowNoScanLayer" title="玻片信息" width="800">
        <layer-table></layer-table>
      </Modal>
    </div>
  </div>
</template>

<script>
import LayerTable from '../table/LayerTable'
export default {
  name: 'scanNumber',
  components: {LayerTable},
  data () {
    return {
      $vue: '',
      // caseSalideNum: 0,
      // hasUploadNum: 0,
      // hasScanNum: 0,
      // waitScanNum: 0,
      // dingScanNum: 0
      zbls: 0,
      zbps: 0,
      zupload: 0,
      ydayCaseNum: 0,
      ydaySlideNum: 0,
      ydayLayerNum: 0,
      ydayUploadLayerNum: 0,
      tdayCaseNum: 0,
      tdaySlideNum: 0,
      tdayLayerNum: 0,
      tdayUploadLayerNum: 0,
      dingScanNum: 0,
      isShowNoScanLayer: false,
      lastUpdateTime: null
    }
  },
  beforeMount () {
    this.$vue = this
    this.getSlideNum()
    // 每1分钟执行一次查询
    setInterval(this.getSlideNum, 60000)
  },
  methods: {
    // 获取各状态玻片个数
    async getSlideNum () {
      this.lastUpdateTime = new Date().toLocaleTimeString()
      let params = new URLSearchParams()
      params.append('laboratoryId', localStorage.getItem('laboratoryId'))
      params.append('userId', localStorage.getItem('userId' + localStorage.getItem('userName')))
      let suc = await this.$http.post(this.$vue.getData('GET_DIF_STATE_SLIDE_NUM_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        this.dingScanNum = data[0].num
        this.zbls = data[1].num
        this.zbps = data[2].num
        this.zupload = data[3].num
        this.ydayCaseNum = data[4].num
        this.ydaySlideNum = data[5].num
        this.ydayLayerNum = data[6].num
        this.ydayUploadLayerNum = data[7].num
        this.tdayCaseNum = data[8].num
        this.tdaySlideNum = data[9].num
        this.tdayLayerNum = data[10].num
        this.tdayUploadLayerNum = data[11].num

        // this.caseSalideNum = 0
        // for (let i = 0; i < data.length; i++) {
        //   let item = data[i]
        //   if (item.state === 0) {
        //     this.waitScanNum = item.num
        //   } else if (item.state === 10) {
        //     this.hasScanNum = item.num
        //   } else if (item.state === 20) {
        //     this.hasUploadNum = item.num
        //   } else if (item.state === 5) {
        //     this.dingScanNum = item.num
        //   }
        //   this.caseSalideNum += item.num
        // }
      }
    },
    // 查询所有未扫描的玻片
    getNoScanLayer () {
      this.isShowNoScanLayer = true
    },
    startScan () {
      /* eslint-disable */
      AsyncTest.openCaseScanning(0 ,function(str){
        //alert(str);
      })
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .describe-text
    line-height 40px
    /*margin-top 10%*/
    div
      font-size 16px
    .ivu-col-span-8
      font-weight bolder
      color #2d8cf0
</style>



// WEBPACK FOOTER //
// src/components/base/scan/ScanNumber.vue